(() => {
  const initInfiniteScroll = (scope = document) => {
    scope.querySelectorAll('[data-ci-collection][data-infinite-scroll="true"]').forEach((section) => {
      if (section.dataset.ajaxinateReady === 'true') return;
      if (typeof Ajaxinate === 'undefined') return;

      section.dataset.ajaxinateReady = 'true';

      new Ajaxinate({
        method: 'scroll',
        loadingText: 'Loading…',
        callback: () => {
          if (typeof window.initMerchProductCards === 'function') {
            window.initMerchProductCards(section);
          }
        },
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initInfiniteScroll());
  document.addEventListener('shopify:section:load', (event) => {
    initInfiniteScroll(event.target || document);
  });
})();
